import { setOptionsFromSdk } from '../../../../utils/push-notifications-utils';
import { unHideElement } from '../../../../utils/dom-utils';

const $WPNEdit = document.querySelector('#WPNEditLabel');

export const initInPage = async ({ actions, htmlProps, sdk, handlers, elementIdInPage }) => {
  unHideElement($WPNEdit.parentNode);
  $WPNEdit?.addEventListener('click', () => {
    handlers.handleWPNEditInPageClick(elementIdInPage);
  });

  if (sdk?.channel?.optedIn) {
    setOptionsFromSdk({ sdk, selectBoxes: htmlProps.selectBoxes, actions });
  }
};
